import React from 'react';
import { Route } from 'react-router-dom';

import { pageWithLayout } from './containers/page';

import GitHubBrowser from './views/GitHubRepositoryBrowser/GitHubRepositoryBrowser';
import ForgeSchemasLocalizationBroswer from './views/ForgeSchemasLocalizationBrowser/ForgeSchemasLocalizationBroswer';
import About from './views/About/About';
import {
  FORGE_SCHEMA_TITLE,
  FORGE_SCHEMA_REPOSITORY,
  FORGE_SCHEMA_OWNER,
  FORGE_SCHEMA_BRANCH,
  FORGE_SCHEMA_ROOT_FOLDER,
  TEST_SCHEMA_TITLE,
  TEST_SCHEMA_REPOSITORY,
  TEST_SCHEMA_OWNER,
  TEST_SCHEMA_BRANCH,
  TEST_SCHEMA_ROOT_FOLDER,
} from './service/constants';

export const Routes = (props) => (
  <div className="app">
    <Route
      path="/"
      exact
      render={(renderProps) => (
        <GitHubBrowser
          repositoryName={FORGE_SCHEMA_REPOSITORY}
          repositoryOwner={FORGE_SCHEMA_OWNER}
          branchName={FORGE_SCHEMA_BRANCH}
          rootFolder={FORGE_SCHEMA_ROOT_FOLDER}
          title={FORGE_SCHEMA_TITLE}
          {...props}
          {...renderProps}
        />
      )}
    />
    <Route
      path="/schemalocals"
      exact
      render={(renderProps) => <ForgeSchemasLocalizationBroswer {...props} {...renderProps} />}
    />
    <Route
      path="/schemahfdmforked"
      exact
      render={(renderProps) => (
        <GitHubBrowser
          repositoryName={TEST_SCHEMA_REPOSITORY}
          repositoryOwner={TEST_SCHEMA_OWNER}
          branchName={TEST_SCHEMA_BRANCH}
          rootFolder={TEST_SCHEMA_ROOT_FOLDER}
          {...props}
          {...renderProps}
        />
      )}
    />
    <Route
      path="/testschema"
      exact
      render={(renderProps) => (
        <GitHubBrowser
          repositoryName={TEST_SCHEMA_REPOSITORY}
          repositoryOwner={TEST_SCHEMA_OWNER}
          branchName={TEST_SCHEMA_BRANCH}
          rootFolder={TEST_SCHEMA_ROOT_FOLDER}
          title={TEST_SCHEMA_TITLE}
          {...props}
          {...renderProps}
        />
      )}
    />
    <Route path="/about" render={(renderProps) => <About {...props} {...renderProps} />} />
  </div>
);

export default pageWithLayout(Routes);
